import { Box, IconButton } from '@youversion/design-system-components';
import ChevronLeftStroked from '@youversion/design-system-icons/lib/ChevronLeftStroked';
import ModalHeader from 'components/ui/modal/Header';
import PaymentMethodsAdd from 'components/views/giving/payment-methods-add';
import { useTranslation } from 'next-i18next';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { firebaseLogEvent } from 'utils/firebase';

interface Props {
  header: Element | DocumentFragment | null;
  onAddBank: () => void;
  onAddCard: () => void;
  onBack?: () => void;
}

export default function PaymentMethodAddDialog({ header, onBack, onAddCard, onAddBank }: Props) {
  const { t } = useTranslation('common');

  useEffect(() => void firebaseLogEvent('GivingScreenView', { screen: 'giving_add_payment_method' }), []);

  return (
    <>
      {header
        ? createPortal(
            <ModalHeader
              left={
                onBack ? (
                  <IconButton
                    className='inline-end-2 block-start-2'
                    data-testid='modal-back-button'
                    onClick={() => {
                      firebaseLogEvent('GivingButtonTap', { label: 'Cancel', screen: 'giving_add_payment_method' });
                      onBack();
                    }}
                  >
                    <span className='sr-only'>{t('giving.navigation.back')}</span>
                    <ChevronLeftStroked className='text-text-light dark:text-text-dark rtl:rotate-180' />
                  </IconButton>
                ) : null
              }
              title={t('giving.titles.add_payment_method')}
            />,
            header
          )
        : null}
      <Box className='grow overflow-x-auto pli-3 pbs-0.5'>
        <PaymentMethodsAdd onAddBank={onAddBank} onAddCard={onAddCard} />
      </Box>
    </>
  );
}
